import { Editor, Element, Node, Path, Range, Transforms } from 'slate';
import { isTag } from './navigation';

export const isExclude = (n: Node): boolean => Element.isElement(n) && (n as any).type === 'exclude';

export function insertExclude(editor: Editor): void {
  if (!editor.selection || Range.isCollapsed(editor.selection)) return;
  Transforms.wrapNodes(editor, { type: 'exclude', children: [] } as any, { split: true, at: editor.selection });
}

export function removeExclude(editor: Editor, at: Path): void {
  Transforms.unwrapNodes(editor, { at, match: isExclude });
}

export function convertTagToExclude(editor: Editor, tagId: string): boolean {
  const entry = Array.from(Editor.nodes(editor, { at: [], match: (n) => isTag(n) && (n as any).tagId === tagId }))[0];
  if (!entry) return false;
  const [, path] = entry;
  Transforms.setNodes(editor, { type: 'exclude' } as any, { at: path });
  Transforms.unsetNodes(editor, ['tagId', 'tagType', 'continuedAt'], { at: path });
  return true;
}
